import { ViewStream } from "spyne";
import { ExternalEventsTraits } from "traits/external-events-traits";

export class UIExternalEventsLauncher extends ViewStream {
  constructor(props = {}) {
    props.id = "external-events-launcher";
    props.traits = [ExternalEventsTraits];
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [["CHANNEL_EXTERNAL_EVENTS_LAUNCHER_EVENT", "onExternalEvent"]];
  }

  onExternalEvent(e) {
    const { payload } = e;

    const { externalEvent, externalEventVal } = payload;

    this.externalEvent$CallEvent(externalEvent, externalEventVal);

   //console.log("NULL LISTENER ", { externalEvent, externalEventVal, payload });
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {
    this.addChannel("CHANNEL_EXTERNAL_EVENTS_LAUNCHER");
  }
}
